<template>
    <div class="inputs">
        <field-input :class="[projectFound ? 'projectFound' : 'projectNotFound']" v-model="form.query" placeholder="Project Number" @keyup="verify()" :maxlength="10"
        ></field-input>

        <!-- <field-input :class="[projectFound ? 'projectFound' : projectFoundClass ]" v-model="form.query" placeholder="Project Number" @keyup="verify()" :maxlength="10" ></field-input> -->

        <div v-if="projectFound">
            <p class="text-success" v-text="projectInfo"></p>
        </div>
        <field-input v-model="form.trigger" placeholder="Trigger"></field-input>

        <!-- <search-user v-model="form.employer_id" filter="employers" placeholder="Employer" ></search-user> -->
        <!-- <search-user v-model="form.technician_id" filter="technicians" placeholder="Technician" ></search-user> -->
        <search-user v-model="form.inspector_id" filter="inspectors" :without-me="0" placeholder="Inspector" ></search-user>

        <!-- <field-select v-model="form.technician_id" placeholder="Techinican">
            <option v-for="user in usersInProject" :value="user.id" v-text="user.name"></option>
        </field-select> -->

        <div class="form-group">
            <label for="app-input-20">Techinican</label>
            <select v-model="form.technician_id" placeholder="Techinican" class="form-control">
                <option value="" default >Select option...</option>
                <option v-for="user in usersInProject" :value="user.id" v-text="user.name"></option>
            </select>
        </div>

        <field-select v-model="form.type" placeholder="Type">
            <option value="certificate">Certificate</option>
            <option value="recertificate">Recertificate</option>
            <option value="random">Random</option>
        </field-select>
    </div>
</template>

<script>
    export default {

        props: {
            form: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                usersInProject: [],
                projectFound: false,
                projectInfo: '',
                color: '',
                borderColor: 'rgb(0 123 255 / 25%)'
            }
        },

        methods: {
            verify: _.debounce(function () {
                this.form.post(`field-inspections/validate-project`).then(response => {

                    if (!response) {
                        Toast.error(`No projects found with number "${this.form.query}"`);
                        this.projectFound = false;
                        this.color = 'red';
                        this.borderColor = 'red';
                        this.usersInProject = []
                        this.form.technician_id = '';
                        return;
                    }

                    this.projectFound = true;
                    this.color = 'green';
                    this.borderColor = 'green';

                    this.usersInProject = response.users;

                    if (this.usersInProject.length == 1) {
                        this.form.technician_id = this.usersInProject[0].id;
                    }

                    this.$emit('on-project', response.project)
                    this.form.project_id = response.project.id;
                    this.projectInfo = response.project.name + ', ' + response.project.address;

                });
            }, 500),
        }
    }
</script>

<style>
.projectFound input {
    color: v-bind(color );
}

.projectFound .form-control:focus {
    color: v-bind(color);
    box-shadow: 0 0 0 0.2rem v-bind(color) !important;
}

.projectNotFound input {
    color: v-bind(color );
}

.projectNotFound .form-control:focus {
    color: v-bind(color);
    box-shadow: 0 0 0 0.2rem v-bind(borderColor) !important;
}
</style>
